import type { FieldError } from 'react-hook-form';
import Icon from '../../Icon';

interface ComboboxErrorProps {
  error: FieldError | null | undefined;
  errorId: string;
}

export function ComboboxError({ error, errorId }: ComboboxErrorProps) {
  if (!error) return null;

  return (
    <div
      id={errorId}
      className="typ-headline-2xs mt-2 flex items-start justify-start space-x-1 text-red-100"
    >
      <Icon type="alert-diamond" solid size="tiny" />
      <span className="flex-1">{error.message}</span>
    </div>
  );
}
